import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { WizardShellComponentService } from 'app/ai/services/wizard-shell-component.service';
import { HeaderComponent } from './shared/components/header/header.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  wizardShellComponentService = inject(WizardShellComponentService);
}
